export default __webpack_public_path__ + "static/media/errorS.354c43a8.webp";